import {
  buildMetadata,
  buildBlogPostingJsonLd,
  buildFaqJsonLd,
  buildCollectionJsonLd,
  blogUrl,
} from "@opinly/shared";
import { api } from "./api";
import { SEO_CONSTANTS } from "./usePageMeta";

export const BLOG_PREFIX = "/blog";

// imagesPrefix comes from the server (null until the Opinly CDN namespace is set).
export const opinlyConfig = (imagesPrefix) => ({
  imagesPrefix: imagesPrefix || "",
  siteUrl: SEO_CONSTANTS.PROD_HOST,
  blogPrefix: BLOG_PREFIX,
  siteName: SEO_CONSTANTS.BASE,
});

export const fetchBlogPosts = (cursor) =>
  api
    .get("/blog/posts", { params: cursor ? { limit: 12, cursor } : { limit: 12 } })
    .then((r) => r.data);

export const fetchBlogPost = (slug) =>
  api.get(`/blog/posts/${encodeURIComponent(slug)}`).then((r) => r.data);

export const formatPostDate = (iso) => {
  const d = iso ? new Date(iso) : null;
  if (!d || Number.isNaN(d.getTime())) return "";
  return d.toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" });
};

export function blogIndexSeo() {
  const config = opinlyConfig(null);
  const url = blogUrl(config);
  return {
    title: "Blog · Research notes & reference guides",
    description:
      "Plain-English articles from Medical Peptide Store on research reference standards, batch documentation, storage, and laboratory handling. For research use only.",
    canonicalPath: BLOG_PREFIX,
    jsonLd: [buildCollectionJsonLd({ name: `${SEO_CONSTANTS.BASE} Blog`, url })],
  };
}

export function postSeo(post, config) {
  const meta = buildMetadata({ type: "post", data: post }, config);
  const hasImages = Boolean(config.imagesPrefix);
  const heroKey = hasImages ? post.titleFile?.fileKey : null;
  const posting = {
    ...buildBlogPostingJsonLd({ ...post, imageFileKey: heroKey }, config),
    url: meta.canonicalUrl,
    mainEntityOfPage: { "@type": "WebPage", "@id": meta.canonicalUrl },
    publisher: {
      "@type": "Organization",
      "@id": `${SEO_CONSTANTS.PROD_HOST}/#organization`,
      name: SEO_CONSTANTS.BASE,
    },
  };
  const jsonLd = [posting];
  if (post.faqs?.length) jsonLd.push(buildFaqJsonLd(post.faqs));
  return {
    title: post.metaTitle || meta.title,
    description: post.metaDescription || meta.description,
    canonicalPath: `${BLOG_PREFIX}/${post.slug}`,
    ogImage: hasImages ? meta.ogImage : undefined,
    ogType: "article",
    jsonLd,
  };
}
